
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqX6ntafs4085UZhaCqzIup2USjq364jLMUBAgVWYj_PQMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/faq.vue?macro=true";
import { default as cartkqSpk_45mFakwgxm5LoKJJRyhV7GvwrvI_45PVZlkIVmImcMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/cart.vue?macro=true";
import { default as index34jchbPl4zwj5wY63Kj8Dlzwe8StYwii3dADUfdjgGEMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/index.vue?macro=true";
import { default as searchgxht6q2LNp792D3k0sELYslnnRbeEyLzsivBFuL63tsMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/search.vue?macro=true";
import { default as sitemap6z9kml6ODZZT7kCWqRpWsvyaQ4T5CjCw9BCmgDoXCWcMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/sitemap.vue?macro=true";
import { default as checkoutpIMS3eRupeE5zkIoRtR5WL4UIWZkEq3F_qczfSsTp4MMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/checkout.vue?macro=true";
import { default as designeroS_MnFWYjNJCLOqMUD4t_458C27Q7RPAwmpcpbxWiapiMMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/designer.vue?macro=true";
import { default as unsubscribe0s_452R9VmSJu4ZCWaAaJrXBWbGIEv9wQv_45BJMNe_45qmocMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/unsubscribe.vue?macro=true";
import { default as card_45paymentwxFq3dflW0HtVAgu7AqBSqtBHaLLidXm_45Ub7aFmvyQQMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/card-payment.vue?macro=true";
import { default as signin1Z4FaQP7b93Yie6LeiZXpPOEGl5sM_aIt613eIqILg8Meta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/guest/signin.vue?macro=true";
import { default as signup1djNHdJf_4FIfvuZdIUYJq5wn3yYilD5_45jXIcuvsLvUMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/guest/signup.vue?macro=true";
import { default as verifyGGRXCLaT_459BC_45VYudMUd0tTuak_5arz_45_45_QjazQjL_0Meta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/guest/verify.vue?macro=true";
import { default as order_45success8ZqG9W8Wr3jeH2z_45t8KTov_Jf25LXKkN_45R4M30AUjPoMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/order-success.vue?macro=true";
import { default as _91slugId_93xo1Z1ISjXU5qWtdq82KY7YliCgH7uTElwdRFsyMQQPMMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/page/[slugId].vue?macro=true";
import { default as thank_45youVzVEpER7Bxi_YrARv56VLAeZE4yhCywBK5QcT0zz_n0Meta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/page/thank-you.vue?macro=true";
import { default as projectmC4SVkAI16eWA5OoO0soCM_pgwvnbdbvIRFCN540pgwMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/project.vue?macro=true";
import { default as uploadermlXgM_wVovp8WCVijthqzAj91J47nJ5o7wBbiXxsCpcMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/uploader.vue?macro=true";
import { default as _91slugId_93jIqpE2ejS9Hu3Gm3EGh4X3UFXq1Qb_Q0GeO6Yaby7ZUMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/catalog/[slugId].vue?macro=true";
import { default as productsAZkGjjoZupN9qVH5hUK_1MEbBp0zEe_45udMg_45k_450Lo0EMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/catalog/products.vue?macro=true";
import { default as _91slugId_93XJnHS3UU2Dd56u9gKJ3X__45HDl_45m_45RyxFWCjPGBS1AB8Meta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/product/[slugId].vue?macro=true";
import { default as thank_45youW6HnRsAxdfJXL9p7jP7vFQHkk0Qk3sluq90uXU4SwVEMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/thank-you.vue?macro=true";
import { default as admin_45authMuUcKBPXDn_45RWXOCe1vj2yA72PyAIa3guFkBv3FucI0Meta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/customer/admin-auth.vue?macro=true";
import { default as _91_46_46_46params_93ljCPPsKp2YjmJ_K89LwQUhnJh10BzSyukhNS4VQN9EkMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/customer/[...params].vue?macro=true";
import { default as reset_45passwordh2VwPdetQJofp3YFWHjGtZcJDZDYSZxIyXDjp78Rg7UMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/guest/reset-password.vue?macro=true";
import { default as video_45library8oO6v2pSdjMXt3Sq3K5dTdP6ym4JhWsiBVXqRnoIcwgMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/video-library.vue?macro=true";
import { default as video_45messageckPaxc_X0tg_453h5Z5xmBf4SRuf4EriwPaCy1MHhR1jsMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/video-message.vue?macro=true";
import { default as claim_45giftiIc3mpM2BuIAnvz3wAr_J5z9G9G2rr1AigdnvSikQOYMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/campaign/claim-gift.vue?macro=true";
import { default as email_45previewMQg5EIT5NgAzo_45oFvnVsfneXskQ7rl4E6ks45rZatPIMeta } from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/campaign/email-preview.vue?macro=true";
export default [
  {
    name: "faq___en_customusb",
    path: "/faq",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/faq.vue")
  },
  {
    name: "cart___en_customusb",
    path: "/cart",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/cart.vue")
  },
  {
    name: "index___en_customusb",
    path: "/",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/index.vue")
  },
  {
    name: "search___en_customusb",
    path: "/search",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/search.vue")
  },
  {
    name: "sitemap___en_customusb",
    path: "/sitemap",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/sitemap.vue")
  },
  {
    name: "checkout___en_customusb",
    path: "/checkout",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/checkout.vue")
  },
  {
    name: "designer___en_customusb",
    path: "/designer",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/designer.vue")
  },
  {
    name: "unsubscribe___en_customusb",
    path: "/unsubscribe",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/unsubscribe.vue")
  },
  {
    name: "card-payment___en_customusb",
    path: "/card-payment",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/card-payment.vue")
  },
  {
    name: "guest-signin___en_customusb",
    path: "/guest/signin",
    meta: { ...(signin1Z4FaQP7b93Yie6LeiZXpPOEGl5sM_aIt613eIqILg8Meta || {}), ...{"middleware":["customer"]} },
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/guest/signin.vue")
  },
  {
    name: "guest-signup___en_customusb",
    path: "/guest/signup",
    meta: { ...(signup1djNHdJf_4FIfvuZdIUYJq5wn3yYilD5_45jXIcuvsLvUMeta || {}), ...{"middleware":["customer"]} },
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/guest/signup.vue")
  },
  {
    name: "guest-verify___en_customusb",
    path: "/guest/verify",
    meta: verifyGGRXCLaT_459BC_45VYudMUd0tTuak_5arz_45_45_QjazQjL_0Meta || {},
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/guest/verify.vue")
  },
  {
    name: "order-success___en_customusb",
    path: "/order-success",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/order-success.vue")
  },
  {
    name: "page-slugId___en_customusb",
    path: "/page/:slugId()",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/page/[slugId].vue")
  },
  {
    name: "page-thank-you___en_customusb",
    path: "/page/thank-you",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/page/thank-you.vue")
  },
  {
    name: "shared-project___en_customusb",
    path: "/shared/project",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/project.vue")
  },
  {
    name: "shared-uploader___en_customusb",
    path: "/shared/uploader",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/uploader.vue")
  },
  {
    name: "catalog-slugId___en_customusb",
    path: "/catalog/:slugId()",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/catalog/[slugId].vue")
  },
  {
    name: "catalog-products___en_customusb",
    path: "/catalog/products",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/catalog/products.vue")
  },
  {
    name: "product-slugId___en_customusb",
    path: "/product/:slugId()",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/product/[slugId].vue")
  },
  {
    name: "shared-thank-you___en_customusb",
    path: "/shared/thank-you",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/thank-you.vue")
  },
  {
    name: "customer-admin-auth___en_customusb",
    path: "/customer/admin-auth",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/customer/admin-auth.vue")
  },
  {
    name: "customer-params___en_customusb",
    path: "/customer/:params(.*)*",
    meta: { ...(_91_46_46_46params_93ljCPPsKp2YjmJ_K89LwQUhnJh10BzSyukhNS4VQN9EkMeta || {}), ...{"middleware":["customer"]} },
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/customer/[...params].vue")
  },
  {
    name: "guest-reset-password___en_customusb",
    path: "/guest/reset-password",
    meta: { ...(reset_45passwordh2VwPdetQJofp3YFWHjGtZcJDZDYSZxIyXDjp78Rg7UMeta || {}), ...{"middleware":["customer"]} },
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/guest/reset-password.vue")
  },
  {
    name: "shared-video-library___en_customusb",
    path: "/shared/video-library",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/video-library.vue")
  },
  {
    name: "shared-video-message___en_customusb",
    path: "/shared/video-message",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/video-message.vue")
  },
  {
    name: "shared-campaign-claim-gift___en_customusb",
    path: "/shared/campaign/claim-gift",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/campaign/claim-gift.vue")
  },
  {
    name: "shared-campaign-email-preview___en_customusb",
    path: "/shared/campaign/email-preview",
    component: () => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/pages/shared/campaign/email-preview.vue")
  }
]